import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const FoodRestaurantComp = ({ btn, titleone, titletwo }) => {
  const foodRestaurantInfo = (
    <>
      <p>
        The <strong>Food and Restaurant Market</strong> is a platform where
        users can discover <strong>restaurants</strong> and explore their{" "}
        <strong>menus</strong>.
      </p>
      <p>
        On this platform, users can search for their favorite restaurants and
        view showcases of available food items and menus. It operates as a{" "}
        <strong>Business-to-Consumer (B2C)</strong> connectivity platform,
        connecting restaurants directly with customers.
      </p>
      <p>
        This marketplace makes it easy for users to{" "}
        <strong>browse options, compare menus,</strong> and choose food
        according to their preferences, all from one convenient platform.
      </p>
      <a href="https://www.youtube.com" target="_blank">
        <strong>Click here to see how to Explore the Food Services</strong>
      </a>
    </>
  );

  return (
    <div>
      <Row className="set-one">
        <Col lg="12">
          {/* CardNav displays title + full food & restaurant info */}
          <CardNav Header={titleone} myid={1} myinfo={foodRestaurantInfo} />

          {/* BoxData for Food & Restaurant */}
          <Card className="shadow-main mt-2">
            <BoxData
              Title="Food Providers"
              Butonn={btn}
              imgg={images.Foodbar}
              url="/BuyRestaurantFood"
              link="/BuyRestaurantFood"
              ms="twentysix-element"
              buy="twenty-four"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default FoodRestaurantComp;
